import {Navigate, Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import EmailConfirmation from './components/EmailConfirmation'
import {SetPassword} from './components/SetPassword'
import ResetPassword from './components/ResetPassword'
import RegistrationGuard from '../user/components/permissions/RegistrationGuard'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route
        path='registration'
        element={
          <RegistrationGuard>
            <Registration />
          </RegistrationGuard>
        }
      />
      <Route path='/forgot-password' element={<ForgotPassword />} />
      <Route path='/reset-password/:token' element={<ResetPassword />} />
      <Route path='/set-password/:token' element={<SetPassword />} />
      <Route path='/email-confirmation' element={<EmailConfirmation />} />
      <Route path='/email-confirmation/:token' element={<EmailConfirmation />} />
      <Route index element={<Login />} />
      {/* Route path to handle any invalid url, it will redirect to login page  */}
      <Route path='*' element={<Navigate to='/login' replace />} />
    </Route>
  </Routes>
)

export {AuthPage}
